function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import * as ramda from 'ramda';
import { InputGroup, Input, Button, InputGroupAddon, Form } from 'reactstrap';
import OptionNestedPickerFieldOptions from './optionNestedPickerFieldOptions';
import OptionNestedPickerFieldBreadcrumbs from './optionNestedPickerFieldBreadcrumbs';
import OptionNestedPickerFieldBack from './optionNestedPickerFieldBack';
import { identifierExistsInTree, pruneTree, removeFromTree, leafSelectionsToSubtitle } from './optionNestedPickerHelpers';
import { leafPedigreesString } from '../../../../../behaviors/src/lib/common';
import { removeNulls } from '../../../../utils/contentTools';
const getIdentifier = option => option.identifier || `_${option.title}`;
class OptionNestedPickerField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      otherValue: ''
    };
    this.onBack = this.onBack.bind(this);
    this.onCrumbSelect = this.onCrumbSelect.bind(this);
    this.onLeafSelect = this.onLeafSelect.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onBack = this.onBack.bind(this);
    this.isSelectedFromProps = this.isSelectedFromProps.bind(this);
    this.onForwardSelect = this.onForwardSelect.bind(this);
    this.currentOptionsFromState = this.currentOptionsFromState.bind(this);
    this.onOtherSelect = this.onOtherSelect.bind(this);
  }
  onBack() {
    const {
      selected
    } = this.state;
    this.setState({
      selected: ramda.slice(0, -1, selected)
    });
  }
  onCrumbSelect(crumb) {
    const {
      selected
    } = this.state;
    const index = selected.findIndex(({
      identifier
    }) => identifier === getIdentifier(crumb));
    this.setState({
      selected: ramda.slice(0, index + 1, selected)
    });
  }
  onLeafSelect(option) {
    const {
      identifier,
      title,
      _created
    } = option;
    const {
      selected
    } = this.state;
    const {
      value,
      onChange,
      allowsMultipleSelection
    } = this.props;
    let tree = JSON.parse(JSON.stringify(value || {}));
    const isSelected = identifierExistsInTree(tree, identifier);
    if (isSelected) {
      tree = removeFromTree(tree, identifier);
    } else {
      if (!allowsMultipleSelection) {
        tree = {};
        onChange({
          value: null
        });
      }
      if (selected.length === 0) {
        tree[identifier] = {
          title,
          _created
        };
      } else {
        const myTree = tree;
        selected.forEach(selection => {
          if (!tree[selection.identifier]) {
            tree[selection.identifier] = {
              title: selection.title,
              /* eslint-disable-next-line no-underscore-dangle */
              _created: selection._created
            };
          }
          if (!tree.children) {
            tree[selection.identifier].children = {};
          }
          tree = tree[selection.identifier].children;
        });
        tree[identifier] = {
          _created,
          title
        };
        tree = myTree;
      }
    }
    const changeModifiers = {};
    const val = pruneTree(tree);
    // removeNulls mutates value...
    const d = JSON.parse(JSON.stringify(val));
    const displayValue = leafPedigreesString(removeNulls(d));
    return onChange({
      value: val,
      displayValue,
      changeModifiers
    });
  }
  onSelect(option) {
    const {
      allowsParentSelection
    } = this.props;
    const forceParentSelect = allowsParentSelection;
    this.onForwardSelect(option, forceParentSelect);
  }
  onForwardSelect(option, forceParentSelect = false) {
    const {
      allowsParentSelection
    } = this.props;
    if (!option.hasChildren || forceParentSelect) {
      this.onLeafSelect(option);
      if (allowsParentSelection || !forceParentSelect) {
        return;
      }
    }
    const {
      selected
    } = this.state;
    const {
      identifier
    } = ramda.last(selected) || {};
    let updatedSelected;
    if (identifier === option.identifier) {
      updatedSelected = ramda.slice(0, -1, selected);
    } else {
      updatedSelected = ramda.append(option, selected);
    }
    this.setState({
      selected: updatedSelected
    });
  }
  onOtherSelect(event) {
    if (event && event.preventDefault !== undefined) {
      event.preventDefault();
    }
    const {
      otherValue
    } = this.state;
    this.onSelect({
      title: otherValue,
      identifier: uuid(),
      _created: moment().toISOString()
    });
    this.setState({
      otherValue: ''
    });
  }
  isSelectedFromProps(identifier) {
    const {
      value
    } = this.props;
    return identifierExistsInTree(value, identifier);
  }
  currentOptionsFromState() {
    const {
      selected
    } = this.state;
    const {
      options,
      value
    } = this.props;
    let optionsToShow = options;
    let othersToShow = ramda.clone(value);
    selected.forEach(selection => {
      const {
        identifier
      } = selection;
      if (othersToShow && othersToShow[identifier] && othersToShow[identifier].children) {
        othersToShow = othersToShow[identifier].children;
      } else {
        othersToShow = [];
      }
      const foundOption = optionsToShow.find(option => getIdentifier(option) === identifier);
      if (foundOption) {
        optionsToShow = foundOption.options || [];
      }
    });
    if (othersToShow) {
      othersToShow = Object.keys(othersToShow).filter(key => !optionsToShow.some(option => getIdentifier(option) === key))
      // Only show others if created is not integer
      /* eslint-disable-next-line no-underscore-dangle */.filter(key => !!othersToShow[key] && typeof othersToShow[key]._created !== 'number').map(key => ({
        identifier: key,
        title: othersToShow[key].title,
        /* eslint-disable-next-line no-underscore-dangle */
        _created: othersToShow[key]._created
      }));
    }
    // We're intentionally returning a different structure
    // to ensure we never modify the options in props
    return optionsToShow.concat(othersToShow).filter(option => getIdentifier(option) !== '_undefined').map((option, index) => _objectSpread(_objectSpread({}, option), {}, {
      _created: index + 1,
      _isSelected: this.isSelectedFromProps(getIdentifier(option)),
      _crumbs: leafSelectionsToSubtitle(value, [...selected, {
        identifier: option.identifier
      }]),
      // It's possible for config to not specify an identifier
      // in this case we just prefix the title with an underscore
      identifier: getIdentifier(option),
      hasChildren: !!option.options || option.allowsOther
    }));
  }
  render() {
    const {
      selected,
      otherValue
    } = this.state;
    const {
      backLabel,
      allowsOther,
      className
    } = this.props;
    const options = this.currentOptionsFromState();
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 40
      }
    }, /*#__PURE__*/React.createElement(OptionNestedPickerFieldBack, {
      onBack: this.onBack,
      title: backLabel,
      isShown: !!selected.length
    }), /*#__PURE__*/React.createElement(OptionNestedPickerFieldBreadcrumbs, {
      crumbs: selected,
      onSelect: this.onCrumbSelect
    })), /*#__PURE__*/React.createElement(OptionNestedPickerFieldOptions, {
      className: className,
      options: options,
      onSelect: this.onSelect,
      onForwardSelect: this.onForwardSelect,
      showIcon: true
    }), allowsOther ? /*#__PURE__*/React.createElement(Form, {
      style: {
        marginTop: 5
      },
      onSubmit: this.onOtherSelect
    }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(Input, {
      onChange: event => this.setState({
        otherValue: event.target.value
      }),
      value: otherValue,
      className: "t-onpf-other-input"
    }), /*#__PURE__*/React.createElement(InputGroupAddon, {
      addonType: "append"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "t-onpf-add-other",
      disabled: !otherValue,
      onClick: this.onOtherSelect
    }, "Add Other")))) : null);
  }
}
OptionNestedPickerField.propTypes = {
  backLabel: PropTypes.string,
  allowsOther: PropTypes.bool,
  allowsMultipleSelection: PropTypes.bool,
  allowsParentSelection: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.array])
};
OptionNestedPickerField.defaultProps = {
  allowsParentSelection: true,
  backLabel: '',
  allowsOther: false,
  allowsMultipleSelection: false,
  className: '',
  value: []
};
export default OptionNestedPickerField;